// Mock data for Griya Bakpia Jogja Landing Page

export const translations = {
  id: {
    nav: {
      products: 'Produk',
      benefits: 'Keunggulan',
      testimonials: 'Testimoni',
      contact: 'Kontak',
      orderNow: 'Pesan Sekarang'
    },
    hero: {
      headline: 'Pusat Oleh-Oleh Bakpia Premium Asli Jogja',
      subheadline: 'Nikmati kelembutan bakpia autentik dengan resep rahasia keluarga. Dibuat 100% tanpa pengawet dari bahan berkualitas pilihan. Pesan bakpia online sekarang, kami siapkan fresh setiap hari!',
      primaryCTA: 'Pesan via WhatsApp',
      secondaryCTA: 'Lihat Varian Rasa'
    },
    products: {
      title: 'Varian Rasa Pilihan',
      subtitle: 'Setiap varian dibuat dengan cinta dan bahan berkualitas tinggi',
      variants: [
        {
          id: 1,
          name: 'Bakpia Kacang Hijau',
          description: 'Varian klasik dengan isian kacang hijau premium yang lembut dan manis alami',
          price: 'Rp 45.000',
          image: 'https://images.unsplash.com/photo-1543392883-914cfa6f9ed4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxJbmRvbmVzaWFuJTIwZGVzc2VydHxlbnwwfHx8fDE3NzU3MzY5NjF8MA&ixlib=rb-4.1.0&q=85'
        },
        {
          id: 2,
          name: 'Bakpia Cokelat Lumer',
          description: 'Cokelat premium yang meleleh di mulut, favorit anak-anak dan dewasa',
          price: 'Rp 50.000',
          image: 'https://images.unsplash.com/photo-1695712577095-7f27c7bea54f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxJbmRvbmVzaWFuJTIwZGVzc2VydHxlbnwwfHx8fDE3NzU3MzY5NjF8MA&ixlib=rb-4.1.0&q=85'
        },
        {
          id: 3,
          name: 'Bakpia Keju Premium',
          description: 'Perpaduan sempurna keju berkualitas dengan tekstur bakpia yang renyah',
          price: 'Rp 55.000',
          image: 'https://images.unsplash.com/photo-1695712535779-7ee863e4a54c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxJbmRvbmVzaWFuJTIwZGVzc2VydHxlbnwwfHx8fDE3NzU3MzY5NjF8MA&ixlib=rb-4.1.0&q=85'
        },
        {
          id: 4,
          name: 'Bakpia Ubi Ungu',
          description: 'Isian ubi ungu asli yang kaya nutrisi dan rasa autentik nusantara',
          price: 'Rp 48.000',
          image: 'https://images.pexels.com/photos/29185236/pexels-photo-29185236.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
        }
      ],
      addToCart: 'Tambah',
      perBox: 'per box (isi 10)',
      seeDetail: 'Lihat Detail',
      seeAllMenu: 'Lihat Menu Selengkapnya',
      availableVariants: 'Tersedia varian Bakpia Basah, Kering, dan Premium',
      loading: 'Memuat produk...',
      noProducts: 'Tidak ada produk tersedia'
    },
    benefits: {
      title: 'Kenapa Memilih Kami?',
      subtitle: 'Komitmen kami untuk kualitas dan kepuasan Anda',
      items: [
        {
          title: '100% Halal',
          description: 'Dijamin halal dan higienis, diproduksi dengan standar keamanan pangan'
        },
        {
          title: 'Tanpa Pengawet',
          description: 'Dibuat fresh setiap hari tanpa bahan pengawet, murni alami'
        },
        {
          title: 'Kulit Tipis Isi Padat',
          description: 'Tekstur kulit yang tipis dan renyah dengan isian yang melimpah'
        }
      ],
      trust: {
        title: 'Resep Turun Temurun',
        description: 'Setiap bakpia dibuat dengan penuh kehati-hatian menggunakan resep keluarga yang telah diwariskan selama lebih dari 20 tahun. Kami menjaga keaslian rasa sambil memastikan standar kebersihan modern.',
        features: ['Chef Berpengalaman', 'Fresh Daily']
      }
    },
    testimonials: {
      title: 'Apa Kata Mereka?',
      subtitle: 'Testimoni pelanggan setia kami',
      stats: [
        { number: '1000+', label: 'Pelanggan Puas' },
        { number: '20+', label: 'Tahun Pengalaman' },
        { number: '5.0', label: 'Rating Rata-rata' },
        { number: '100%', label: 'Halal & Higienis' }
      ],
      items: [
        {
          id: 1,
          name: 'Ibu Siti Rahma',
          location: 'Jakarta',
          text: 'Bakpianya enak banget! Kulitnya tipis dan isiannya melimpah. Sudah langganan sejak 2 tahun lalu, selalu beli kalau ke Jogja.',
          rating: 5
        },
        {
          id: 2,
          name: 'Bapak Andi Wijaya',
          location: 'Surabaya',
          text: 'Paling suka varian cokelat lumer, benar-benar meleleh di mulut. Anak-anak saya juga suka!',
          rating: 5
        },
        {
          id: 3,
          name: 'Maya Putri',
          location: 'Bandung',
          text: 'Oleh-oleh favorit untuk keluarga! Rasanya autentik dan kemasannya juga bagus. Recommended!',
          rating: 5
        },
        {
          id: 4,
          name: 'Dimas Prakoso',
          location: 'Semarang',
          text: 'Varian keju premiumnya juara! Gurih dan manisnya pas. Packaging-nya juga eksklusif cocok untuk kado.',
          rating: 5
        }
      ]
    },
    contact: {
      title: 'Hubungi Kami',
      subtitle: 'Ada pertanyaan? Kami siap membantu Anda',
      form: {
        name: 'Nama Lengkap',
        email: 'Email',
        phone: 'Nomor Telepon',
        message: 'Pesan Anda',
        submit: 'Kirim Pesan',
        success: 'Terima kasih! Pesan Anda telah diterima.',
        error: 'Mohon isi semua field yang diperlukan.'
      },
      address: 'Jl. Mangunnegaran Kidul No.18, Panembahan, Kecamatan Kraton',
      phone: '+62 8564 300 2257',
      email: 'info@griyabakpia.com',
      hours: 'Senin - Minggu: 08.00 - 20.00 WIB'
    },
    footer: {
      cta: {
        title: 'Beli 5 Box, Gratis Ongkir Se-Yogyakarta!',
        subtitle: 'Promo terbatas! Pesan sekarang dan nikmati kelezatan bakpia asli Jogja',
        button: 'Pesan via WhatsApp'
      },
      about: 'Griya Bakpia Jogja',
      aboutText: 'Usaha keluarga yang telah berpengalaman lebih dari 20 tahun dalam membuat bakpia khas Jogja dengan resep turun temurun.',
      quickLinks: 'Link Cepat',
      followUs: 'Ikuti Kami',
      copyright: '© 2024 Griya Bakpia Jogja. Hak Cipta Dilindungi.'
    },
    order: {
      menuToko: 'Menu Toko',
      varianPremium: 'Varian Premium',
      bakpiaBasah: 'Bakpia Basah',
      bakpiaKering: 'Bakpia Kering',
      isi: 'Isi',
      tambah: 'Tambah',
      lihatDetail: 'Lihat Detail',
      tutupDetail: 'Tutup Detail',
      totalPembayaran: 'Total Pembayaran',
      checkout: 'Checkout',
      detailPesanan: 'Detail Pesanan',
      ringkasanKeranjang: 'Ringkasan Keranjang',
      dataPengiriman: 'Data Pengiriman',
      form: {
        nama: 'Nama Lengkap*',
        provinsi: 'Provinsi*',
        kota: 'Kota/Kabupaten*',
        kecamatan: 'Kecamatan*',
        kodePos: 'Kode Pos*',
        alamat: 'Alamat Lengkap (Jalan, No Rumah)*',
        detail: 'Detail Tambahan',
        placeholderNama: 'Nama penerima',
        placeholderProvinsi: 'Pilih Provinsi',
        placeholderKota: 'Pilih Kota',
        placeholderKecamatan: 'Pilih Kecamatan',
        placeholderKodePos: 'Kode pos',
        placeholderAlamat: 'Nama jalan, nomor rumah, blok',
        placeholderDetail: 'Patokan, warna pagar, dsb'
      },
      vacuum: 'Gunakan Layanan Vacuum (+Rp 2.500/box)',
      vacuumDesc: 'Disarankan untuk pengiriman luar DIY agar bakpia awet hingga 1 bulan.',
      kosongkan: 'Kosongkan',
      pesanWA: 'Pesan via WA',
      errorIncomplete: 'Mohon lengkapi semua data alamat!',
      errorEmpty: 'Keranjang masih kosong!',
      successMsg: 'Pesanan dikirim ke WhatsApp!',
      confirmClear: 'Apakah Anda yakin ingin mengosongkan seluruh keranjang?',
      cartCleared: 'Keranjang dikosongkan'
    }
  },
  en: {
    nav: {
      products: 'Products',
      benefits: 'Benefits',
      testimonials: 'Testimonials',
      contact: 'Contact',
      orderNow: 'Order Now'
    },
    hero: {
      headline: 'The Softness of Authentic Jogja Bakpia in Every Bite',
      subheadline: 'Made with a secret family recipe, premium ingredients, and baked fresh daily in our kitchen.',
      primaryCTA: 'Order via WhatsApp',
      secondaryCTA: 'See Flavor Variants'
    },
    products: {
      title: 'Featured Flavors',
      subtitle: 'Each variant is made with love and high-quality ingredients',
      variants: [
        {
          id: 1,
          name: 'Mung Bean Bakpia',
          description: 'Classic variant with premium mung bean filling that is soft and naturally sweet',
          price: 'Rp 45,000',
          image: 'https://images.unsplash.com/photo-1543392883-914cfa6f9ed4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxJbmRvbmVzaWFuJTIwZGVzc2VydHxlbnwwfHx8fDE3NzU3MzY5NjF8MA&ixlib=rb-4.1.0&q=85'
        },
        {
          id: 2,
          name: 'Melted Chocolate',
          description: 'Premium chocolate that melts in your mouth, a favorite for kids and adults',
          price: 'Rp 50,000',
          image: 'https://images.unsplash.com/photo-1695712577095-7f27c7bea54f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxJbmRvbmVzaWFuJTIwZGVzc2VydHxlbnwwfHx8fDE3NzU3MzY5NjF8MA&ixlib=rb-4.1.0&q=85'
        },
        {
          id: 3,
          name: 'Premium Cheese',
          description: 'Perfect blend of quality cheese with crispy bakpia texture',
          price: 'Rp 55,000',
          image: 'https://images.unsplash.com/photo-1695712535779-7ee863e4a54c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxJbmRvbmVzaWFuJTIwZGVzc2VydHxlbnwwfHx8fDE3NzU3MzY5NjF8MA&ixlib=rb-4.1.0&q=85'
        },
        {
          id: 4,
          name: 'Purple Sweet Potato',
          description: 'Authentic purple sweet potato filling rich in nutrients and authentic Indonesian taste',
          price: 'Rp 48,000',
          image: 'https://images.pexels.com/photos/29185236/pexels-photo-29185236.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
        }
      ],
      addToCart: 'Add',
      perBox: 'per box (10 pcs)',
      seeDetail: 'See Detail',
      seeAllMenu: 'See Full Menu',
      availableVariants: 'Available in Wet, Dry, and Premium Bakpia variants',
      loading: 'Loading products...',
      noProducts: 'No products available'
    },
    benefits: {
      title: 'Why Choose Us?',
      subtitle: 'Our commitment to quality and your satisfaction',
      items: [
        {
          title: '100% Halal',
          description: 'Guaranteed halal and hygienic, produced with food safety standards'
        },
        {
          title: 'No Preservatives',
          description: 'Made fresh daily without preservatives, purely natural'
        },
        {
          title: 'Thin Skin, Dense Filling',
          description: 'Thin and crispy skin texture with abundant filling'
        }
      ],
      trust: {
        title: '🏺 Heirloom Recipe',
        description: 'Every bakpia is made with great care using a family recipe passed down for over 20 years. We maintain the authentic taste while ensuring modern hygiene standards.',
        features: ['Experienced Chefs', 'Hygienic Production', 'Fresh Daily']
      }
    },
    testimonials: {
      title: 'What They Say?',
      subtitle: 'Testimonials from our loyal customers',
      stats: [
        { number: '1000+', label: 'Happy Customers' },
        { number: '20+', label: 'Years Experience' },
        { number: '5.0', label: 'Average Rating' },
        { number: '100%', label: 'Halal & Hygienic' }
      ],
      items: [
        {
          id: 1,
          name: 'Ibu Siti Rahma',
          location: 'Jakarta',
          text: 'The bakpia is so delicious! The skin is thin and the filling is abundant. Been a regular customer for 2 years, always buy when visiting Jogja.',
          rating: 5
        },
        {
          id: 2,
          name: 'Bapak Andi Wijaya',
          location: 'Surabaya',
          text: 'Love the melted chocolate variant, it really melts in your mouth. My kids love it too!',
          rating: 5
        },
        {
          id: 3,
          name: 'Maya Putri',
          location: 'Bandung',
          text: 'Favorite souvenir for family! Authentic taste and nice packaging. Highly recommended!',
          rating: 5
        },
        {
          id: 4,
          name: 'Dimas Prakoso',
          location: 'Semarang',
          text: 'The premium cheese variant is the best! Perfect balance of savory and sweet. Exclusive packaging perfect for gifts.',
          rating: 5
        }
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have questions? We are here to help',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone Number',
        message: 'Your Message',
        submit: 'Send Message',
        success: 'Thank you! Your message has been received.',
        error: 'Please fill in all required fields.'
      },
      address: 'Jl. Mangunnegaran Kidul No.18, Panembahan, Kecamatan Kraton',
      phone: '+62 8564 300 2257',
      email: 'info@griyabakpia.com',
      hours: 'Monday - Sunday: 08.00 - 20.00 WIB'
    },
    footer: {
      cta: {
        title: 'Buy 5 Boxes, Free Shipping Throughout Yogyakarta!',
        subtitle: 'Limited promo! Order now and enjoy the deliciousness of authentic Jogja bakpia',
        button: 'Order via WhatsApp'
      },
      about: 'Griya Bakpia Jogja',
      aboutText: 'A family business with over 20 years of experience in making authentic Jogja bakpia with traditional recipes passed down through generations.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      copyright: '© 2024 Griya Bakpia Jogja. All Rights Reserved.'
    },
    order: {
      menuToko: 'Store Menu',
      varianPremium: 'Premium Variant',
      bakpiaBasah: 'Wet Bakpia',
      bakpiaKering: 'Dry Bakpia',
      isi: 'Content',
      tambah: 'Add',
      lihatDetail: 'See Details',
      tutupDetail: 'Close Details',
      totalPembayaran: 'Total Payment',
      checkout: 'Checkout',
      detailPesanan: 'Order Details',
      ringkasanKeranjang: 'Cart Summary',
      dataPengiriman: 'Shipping Data',
      form: {
        nama: 'Full Name*',
        provinsi: 'Province*',
        kota: 'City/Regency*',
        kecamatan: 'District*',
        kodePos: 'Postal Code*',
        alamat: 'Full Address (Street, House No)*',
        detail: 'Additional Details',
        placeholderNama: 'Recipient\'s name',
        placeholderProvinsi: 'Select Province',
        placeholderKota: 'Select City',
        placeholderKecamatan: 'Select District',
        placeholderKodePos: 'Postal code',
        placeholderAlamat: 'Street name, house number, block',
        placeholderDetail: 'Landmark, gate color, etc.'
      },
      vacuum: 'Use Vacuum Service (+Rp 2,500/box)',
      vacuumDesc: 'Recommended for shipping outside DIY so bakpia lasts up to 1 month.',
      kosongkan: 'Clear Cart',
      pesanWA: 'Order via WA',
      errorIncomplete: 'Please complete all address data!',
      errorEmpty: 'Cart is still empty!',
      successMsg: 'Order sent to WhatsApp!',
      confirmClear: 'Are you sure you want to empty the entire cart?',
      cartCleared: 'Cart emptied'
    }
  }
};

export const whatsappNumber = '6285101808156'; // Griya Bakpia Jogja WhatsApp number in international format without '+'

export const mapLocation = {  
  lat: -7.80647,
  lng: 110.36852,
  zoom: 15
};

export const socialMedia = {
  instagram: 'https://instagram.com/griyabakpia',
  facebook: 'https://facebook.com/griyabakpia',
  tiktok: 'https://tiktok.com/@griyabakpia'
};
